import {
  BsPerson,
  BsPersonFill,
  BsBag,
  BsInbox,
  BsClock,
  BsCheckCircle,
  BsBell,
  BsHouseDoor,
  BsCollection,
} from "react-icons/bs";
import React from "react";
import logger from "./logger";


export class Constants {
  // Dashboard icon component
  static DashboardIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  );

  // Properties icon component
  static PropertiesIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </svg>
  );

  // Spaces & Services icon component (represents spaces, services, and events)
  static SpacesAndServicesIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" rx="1"></rect>
      <rect x="14" y="3" width="7" height="7" rx="1"></rect>
      <rect x="3" y="14" width="7" height="7" rx="1"></rect>
      <rect x="14" y="14" width="7" height="7" rx="1"></rect>
      <circle cx="6.5" cy="6.5" r="1.5" fill="#3B82F6"></circle>
      <circle cx="17.5" cy="6.5" r="1.5" fill="#3B82F6"></circle>
      <circle cx="6.5" cy="17.5" r="1.5" fill="#3B82F6"></circle>
      <circle cx="17.5" cy="17.5" r="1.5" fill="#3B82F6"></circle>
    </svg>
  );

  // Users icon component (for User Management)
  static UsersIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  );

  // Hosts icon component (single user with badge)
  static HostsIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
      <path d="M15.5 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5z"></path>
    </svg>
  );

  // Search icon component (for Find a Space)
  static SearchIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  );

  // Booking icon component
  static BookingIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  );

  // Settings icon component
  static SettingsIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  );

  // Billing icon component
  static BillingIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  );

  // Package/Orders icon component
  static PackageIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"></path>
      <polyline points="2.32 6.16 12 11 21.68 6.16"></polyline>
      <line x1="12" y1="22.76" x2="12" y2="11"></line>
    </svg>
  );

  // Orders icon component
  static OrdersIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  );

  // Membership Plan icon component
  static MembershipPlanIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
      <path d="M12 7v7"></path>
      <path d="M10 10h4"></path>
    </svg>
  );

  // Roles and Permissions icon component
  static RolesPermissionsIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
      <path d="M2 17l10 5 10-5"></path>
      <path d="M2 12l10 5 10-5"></path>
    </svg>
  );

  // Service Categories icon component
  static ServiceCategoriesIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3h18v18H3z"></path>
      <path d="M3 9h18"></path>
      <path d="M9 21V9"></path>
      <path d="M7 3v6"></path>
      <path d="M17 3v6"></path>
    </svg>
  );

  // Offers & Discounts icon component
  static OffersDiscountsIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1"></circle>
      <circle cx="20" cy="21" r="1"></circle>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
      <path d="M12 8l-2-2m0 0l-2-2m2 2l2-2m-2 2v8"></path>
    </svg>
  );

  // Payment Configuration icon component
  static PaymentConfigIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
      <circle cx="12" cy="16" r="2"></circle>
      <path d="M8 2v4"></path>
      <path d="M16 2v4"></path>
    </svg>
  );

  // Policy Management icon component
  static PolicyManagementIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  );

  // Announcements icon component
  static AnnouncementIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 9v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9"></path>
      <path d="M9 22V12h6v10"></path>
      <path d="M4 13V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8"></path>
    </svg>
  );

  // Navigation items for the sidebar
  static NAV_ITEMS = {
    // Common items for all users
    COMMON: [],

    // Admin specific items
    ADMIN: [
      {
        label: "Dashboard",
        href: "/dashboard",
        icon: <Constants.DashboardIcon />,
      },
      {
        label: "Spaces & Services",
        href: "/spaces-and-services",
        icon: <Constants.PropertiesIcon />,
      },
      {
        label: "Reservations",
        href: "/reservations",
        icon: <Constants.BookingIcon />,
      },
      {
        label: "User Management",
        href: "/user-management",
        icon: <Constants.UsersIcon />,
      },
      {
        label: "Hosts",
        icon: <Constants.HostsIcon />,
        children: [
          { label: "Inactive", href: "/companyApprovals" },
          { label: "Active", href: "/approvedHosts" },
          { label: "Disabled", href: "/disabledHosts" },
        ],
      },
      {
        label: "Billing",
        href: "/orders",
        icon: <Constants.OrdersIcon />,
      },
      {
        label: "Packages",
        href: "/packages",
        icon: <Constants.PackageIcon />,
      },
      {
        label: "Announcements",
        href: "/announcements",
        icon: <Constants.AnnouncementIcon />,
      },
      {
        label: "Settings",
        href: "/settings",
        icon: <Constants.SettingsIcon />,
      },

      {
        label: "Roles & Permissions",
        href: "/roles-permissions",
        icon: <Constants.RolesPermissionsIcon />,
      },
      {
        label: "Service Categories",
        href: "/service-categories",
        icon: <Constants.ServiceCategoriesIcon />,
      },
      {
        label: "Offers & Discounts",
        href: "/offers-discounts",
        icon: <Constants.OffersDiscountsIcon />,
      },
      {
        label: "Payment Configuration",
        href: "/payment-configuration",
        icon: <Constants.PaymentConfigIcon />,
      },
      {
        label: "Policy Management",
        href: "/policy-management",
        icon: <Constants.PolicyManagementIcon />,
      },
    ],

    // Host specific items
    HOST: [
      {
        label: "Dashboard",
        href: "/dashboard",
        icon: <Constants.DashboardIcon />,
      },
      {
        label: "Spaces & Services",
        href: "/spaces-and-services",
        icon: <Constants.PropertiesIcon />,
      },
      {
        label: "Reservations",
        href: "/reservations",
        icon: <Constants.BookingIcon />,
      },
      {
        label: "User Management",
        href: "/user-management",
        icon: <Constants.UsersIcon />,
      },
      {
        label: "Billing",
        href: "/billing",
        icon: <Constants.BillingIcon />,
      },
      {
        label: "Settings",
        href: "/settings",
        icon: <Constants.SettingsIcon />,
      },
    ],

    // Host operations specific items
    HOST_OPERATIONS: [
      {
        label: "Spaces & Services",
        href: "/spaces-and-services",
        icon: <Constants.PropertiesIcon />,
      },
      {
        label: "Reservations",
        href: "/reservations",
        icon: <Constants.BookingIcon />,
      },
      {
        label: "Settings",
        href: "/settings",
        icon: <Constants.SettingsIcon />,
      },
    ],

    // Regular user items
    USER: [
      {
        label: "Find a Space",
        href: "/startbooking",
        icon: <Constants.SearchIcon />,
      },
      {
        label: "Reservations",
        href: "/reservations",
        icon: <Constants.BookingIcon />,
      },
      {
        label: "User Management",
        href: "/user-management",
        icon: <Constants.UsersIcon />,
      },
      {
        label: "Membership Plan",
        href: "/membership-plan",
        icon: <Constants.MembershipPlanIcon />,
      },
      {
        label: "Billing",
        href: "/billing",
        icon: <Constants.BillingIcon />,
      },
      {
        label: "Settings",
        href: "/settings",
        icon: <Constants.SettingsIcon />,
      },
    ],
  };

  static sidebarMenus = [
    {
      icon: "dashboard.svg",
      name: "Dashboard",
      route: "/dashboard",
      restricted_to: ["ROLE_ADMINISTRATOR", "ROLE_HOST"],
    },
    {
      icon: "property-location.svg",
      name: "Spaces & Services",
      route: "/spaces-and-services",
      restricted_to: ["ROLE_ADMINISTRATOR", "ROLE_HOST", "ROLE_HOST_OPERATIONS"],
    },
    {
      icon: "find-a-space.svg",
      name: "Find a Space",
      route: "/startbooking",
      activeRoutes: ["/startbooking", "/filterprops"],
      restricted_to: [
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_SUBSCRIBER_APPROVER",
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
      ],
    },
    {
      icon: "calendar.svg",
      name: "Reservations",
      route: "/reservations",
      restricted_to: [
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_SUBSCRIBER_APPROVER",
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
      ],
    },
    // {
    // 	icon: 'calendar.svg',
    // 	name: "Booking",
    // 	route: "",
    //     restricted_to: ['ROLE_SUBSCRIBER_OWNER', 'ROLE_SUBSCRIBER_APPROVER', 'ROLE_SUBSCRIBER_INDIVIDUAL', 'ROLE_EMPLOYEE', 'ROLE_APPROVER_EMPLOYEE'],
    // 	children: [
    // 		{
    // 			name: "Find a Space",
    // 			route: "/startbooking",
    // 		},
    // 		{
    // 			name: "Reservations",
    // 			route: "/reservations",
    // 		}
    // 		// {
    // 		// 	name: "Pending Approvals",
    // 		// 	route: "/editbooking",
    // 		// },
    // 	],
    // },
    {
      icon: "calendar.svg",
      name: "Reservations",
      route: "/reservations",
      restricted_to: ["ROLE_ADMINISTRATOR", "ROLE_HOST", "ROLE_HOST_OPERATIONS"],
    },
    {
      icon: "users.svg",
      name: "Users",
      route: "/user-management",
      restricted_to: ["ROLE_SUBSCRIBER_OWNER", "ROLE_HOST", "ROLE_ADMINISTRATOR"],
    },
    {
      icon: "bill.svg",
      name: "Billing",
      route: "/billing",
      restricted_to: ["ROLE_HOST"],
    },
    {
      icon: "users.svg",
      name: "Hosts",
      route: "",
      restricted_to: ["ROLE_ADMINISTRATOR"],
      children: [
        {
          name: "Inactive",
          route: "/companyApprovals",
        },
        {
          name: "Active",
          route: "/approvedHosts",
          style: this.menuItemStyle,
          restricted_to: ["ROLE_ADMINISTRATOR"],
        },
        {
          name: "Disabled",
          route: "/disabledHosts",
        },
      ],
    },
    {
      icon: "membership-plan.svg",
      name: "Membership plan",
      route: "/membership-plan",
      restricted_to: [
        "ROLE_HOST",
        "ROLE_SUBSCRIBER_HOST",
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_HOST_CUSTOMER_OWNER",
        "ROLE_SUBSCRIBER_INDIVIDUAL",
      ],
      showForUsersWithoutActiveSubscription: true, // Always show if role is allowed (regardless of subscription status)
    },
    {
      icon: "bill.svg",
      name: "Billing",
      route: "/billing",
      restricted_to: ["ROLE_SUBSCRIBER_OWNER"],
    },
    {
      icon: "bill.svg",
      name: "Billing",
      route: "/orders",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "bill.svg",
      name: "Offers & Discounts",
      route: "/offers-discounts",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "bill.svg",
      name: "Packages",
      route: "/packages",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "chart.svg",
      name: "Announcements",
      route: "/announcements",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    // {
    // 	icon: 'chart.svg',
    // 	name: "Reports",
    // 	route: "/report",
    //     restricted_to: ['ROLE_SUBSCRIBER_OWNER', 'ROLE_ADMINISTRATOR']
    // },
    {
      icon: "settings.svg",
      name: "Settings",
      route: "/settings",
      restricted_to: [
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_SUBSCRIBER_APPROVER",
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_HOST",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
        "ROLE_ADMINISTRATOR",
      ],
    },

    {
      icon: "roles-permissions.svg",
      name: "Roles & Permissions",
      route: "/roles-permissions",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "service-categories.svg",
      name: "Service Categories",
      route: "/service-categories",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "payment-config.svg",
      name: "Payment Configuration",
      route: "/payment-configuration",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: "policy-management.svg",
      name: "Policy Management",
      route: "/policy-management",
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
  ];

  static menuItemStyle = {
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    color: "#333",
    transition: "all 0.2s ease",
    borderRadius: "12px",
    margin: "4px 8px",
    fontSize: "15px",
    fontWeight: 500,
  };

  static menuIconStyle = {
    width: "24px",
    height: "24px",
    marginRight: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  static mobileSidebarMenus = [
    // Landing Pages (No Auth Required)
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsHouseDoor size={20} color={"#666"} />
        </div>
      ),
      name: "Home",
      route: "/home",
      style: this.menuItemStyle,
      restricted_to: ["NO_AUTH"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsBag size={20} color={"#666"} />
        </div>
      ),
      name: "Enterprise Solutions",
      route: "/corporate-page",
      style: {
        ...this.menuItemStyle,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
      },
      restricted_to: ["NO_AUTH"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsPersonFill size={20} color={"#666"} />
        </div>
      ),
      name: "Host",
      route: "/mobile-host",
      style: this.menuItemStyle,
      restricted_to: ["NO_AUTH"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsInbox size={20} color={"#666"} />
        </div>
      ),
      name: "FAQs",
      route: "/frequently-asked-questions",
      style: this.menuItemStyle,
      restricted_to: ["NO_AUTH"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsPerson size={20} color={"#666"} />
        </div>
      ),
      name: "Sign In",
      route: "/signin",
      style: this.menuItemStyle,
      restricted_to: ["NO_AUTH"],
    },
    // Search - For Individual, Owner, Employee, Approver Employee
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.SearchIcon />
        </div>
      ),
      name: "Search",
      route: "/searchPage",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_SUBSCRIBER_INDIVIDUAL", "ROLE_SUBSCRIBER_OWNER", "ROLE_EMPLOYEE", "ROLE_APPROVER_EMPLOYEE"],
    },
    // Spaces and Services - For Host, Host sub-account, Administrator
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.PropertiesIcon />
        </div>
      ),
      name: "Spaces & Services",
      route: "/spaces-and-services",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_HOST", "ROLE_HOST_OPERATIONS", "ROLE_ADMINISTRATOR"],
    },
    // Reservations - For all roles
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.BookingIcon />
        </div>
      ),
      name: "Reservations",
      route: "/reservation",
      style: this.menuItemStyle,
      restricted_to: [
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
        "ROLE_HOST",
        "ROLE_HOST_OPERATIONS",
        "ROLE_ADMINISTRATOR",
      ],
    },
    // Users - For Host, Owner subscriber, Administrator
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.UsersIcon />
        </div>
      ),
      name: "Users",
      route: "/user-management",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_HOST", "ROLE_SUBSCRIBER_OWNER", "ROLE_ADMINISTRATOR"],
    },
    // Membership Plan - For users without active subscription (will be filtered dynamically)
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.MembershipPlanIcon />
        </div>
      ),
      name: "Membership Plan",
      route: "/membership-plan",
      style: this.menuItemStyle,
      restricted_to: [
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_APPROVER_EMPLOYEE",
        "ROLE_EMPLOYEE",
        "ROLE_HOST",
        "ROLE_HOST_OPERATIONS",
        "ROLE_SUBSCRIBER_HOST",
        "ROLE_SUBSCRIBER_HOST_OPERATIONS",
      ],
      showForUsersWithoutActiveSubscription: true, // Special flag for dynamic filtering
    },
    // Administrator-specific menus
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.AnnouncementIcon />
        </div>
      ),
      name: "Announcements",
      route: "/mobile/announcements",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.PackageIcon />
        </div>
      ),
      name: "Packages",
      route: "/mobile/packages",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.OrdersIcon />
        </div>
      ),
      name: "Billing",
      route: "/mobile/orders",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.HostsIcon />
        </div>
      ),
      name: "Hosts",
      route: "/mobile/hosts",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
      subMenus: [
        {
          icon: (
            <div style={this.menuIconStyle}>
              <BsCheckCircle size={20} color={"#666"} />
            </div>
          ),
          name: "Active",
          route: "/mobile/hosts/approved",
          style: this.menuItemStyle,
          restricted_to: ["ROLE_ADMINISTRATOR"],
        },
        {
          icon: (
            <div style={this.menuIconStyle}>
              <BsClock size={20} color={"#666"} />
            </div>
          ),
          name: "Inactive",
          route: "/mobile/hosts/pending",
          style: this.menuItemStyle,
          restricted_to: ["ROLE_ADMINISTRATOR"],
        },
        {
          icon: (
            <div style={this.menuIconStyle}>
              <BsCollection size={20} color={"#666"} />
            </div>
          ),
          name: "Disabled",
          route: "/mobile/hosts/disabledHosts",
          style: this.menuItemStyle,
          restricted_to: ["ROLE_ADMINISTRATOR"],
        },
      ],
    },
    // Settings - For all roles
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.SettingsIcon />
        </div>
      ),
      name: "Settings",
      route: "/profile",
      style: this.menuItemStyle,
      restricted_to: [
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
        "ROLE_HOST",
        "ROLE_HOST_OPERATIONS",
        "ROLE_ADMINISTRATOR",
      ],
    },
    // Notifications - For all roles
    {
      icon: (
        <div style={this.menuIconStyle}>
          <BsBell size={20} color={"#666"} />
        </div>
      ),
      name: "Notifications",
      route: "/notifications",
      style: this.menuItemStyle,
      restricted_to: [
        "ROLE_SUBSCRIBER_INDIVIDUAL",
        "ROLE_SUBSCRIBER_OWNER",
        "ROLE_EMPLOYEE",
        "ROLE_APPROVER_EMPLOYEE",
        "ROLE_HOST",
        "ROLE_HOST_OPERATIONS",
        "ROLE_ADMINISTRATOR",
      ],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.RolesPermissionsIcon />
        </div>
      ),
      name: "Roles & Permissions",
      route: "/roles-permissions",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.ServiceCategoriesIcon />
        </div>
      ),
      name: "Service Categories",
      route: "/service-categories",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
    {
      icon: (
        <div style={this.menuIconStyle}>
          <Constants.OffersDiscountsIcon />
        </div>
      ),
      name: "Offers & Discounts",
      route: "/offers-discounts",
      style: this.menuItemStyle,
      restricted_to: ["ROLE_ADMINISTRATOR"],
    },
  ];

  static BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.spacia.africa/";
  // API Base URLs - all support environment variables from .env.production/.env.development
  // If env vars are set in .env files, they will be used. Otherwise, sandbox fallbacks apply.
  static API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page";

  // Helper function to construct URLs safely
  static getApiBaseUrl() {
    return process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page";
  }

  static SPACE_MANAGEMENT_API_BASE_URL =
    process.env.REACT_APP_SPACE_MANAGEMENT_API_URL ||
    `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/booking`;
  static USER_API_BASE_URL =
    process.env.REACT_APP_USER_API_URL || `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/user`;
  static ORG_API_BASE_URL =
    process.env.REACT_APP_ORG_API_URL || `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/org`;
  static BILLING_API_BASE_URL =
    process.env.REACT_APP_BILLING_API_URL ||
    `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/billing`;
  static PAYMENT_API_BASE_URL =
    process.env.REACT_APP_PAYMENT_API_URL ||
    `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/payment`;
  static CHAT_API_BASE_URL =
    process.env.REACT_APP_CHAT_API_URL || `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/chat`;
  static MESSAGING_API_BASE_URL =
    process.env.REACT_APP_MESSAGING_API_URL ||
    `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/messaging`;
  static INTEGRATIONS_API_BASE_URL =
    process.env.REACT_APP_INTEGRATIONS_API_URL ||
    `${process.env.REACT_APP_API_URL || "https://api.sandbox.spacia.page"}/booking`;
  static GOOGLE_MAPS_API_KEY = "AIzaSyBQQmGg2svzQTx_c2Op5q046-wFhcOSt0A";
  // Also use the Google API key for Gemini API
  static GEMINI_API_KEY =
    process.env.REACT_APP_GEMINI_API_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    "AIzaSyBfJEWn4YSHm-v-JvTB_y0-XdkGc-Ys6UE";
  static GUEST_API_URL = process.env.REACT_APP_GUEST_API_URL;
  static HOST_EXPERIENCE_BASE_COLOR = "#3A36DB";

  // Host Experience navigation items

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  static firebaseConfig = {
    apiKey: "AIzaSyBQQmGg2svzQTx_c2Op5q046-wFhcOSt0A",
    authDomain: "spacia-16ab5.firebaseapp.com",
    projectId: "spacia-16ab5",
    storageBucket: "spacia-16ab5.appspot.com",
    messagingSenderId: "1053152375145",
    appId: "1:1053152375145:web:2773e95b7024c05f3b4df8",
    measurementId: "G-FTF1GB80TL",
  };

  static getMenusByRole(role, _hasActiveSubscription = false) {
    const menus = this.sidebarMenus.filter(menu => {
      // Check if menu is restricted to this role
      const isRoleAllowed = menu.restricted_to.includes(role);

      // Special handling for Membership Plan menu - always show it if role is allowed
      if (menu.showForUsersWithoutActiveSubscription) {
        // Always show Membership Plan if user role is allowed (regardless of subscription status)
        return isRoleAllowed;
      }

      return isRoleAllowed;
    });

    // Debug logging for membership plan visibility
    if (role === "ROLE_SUBSCRIBER_INDIVIDUAL") {
      const membershipPlanMenu = this.sidebarMenus.find(m => m.name === "Membership plan");
      logger.log("🔍 [Constants.getMenusByRole] Membership Plan Menu Debug:", {
        role,
        membershipPlanMenu: membershipPlanMenu
          ? {
              name: membershipPlanMenu.name,
              restricted_to: membershipPlanMenu.restricted_to,
              showForUsersWithoutActiveSubscription: membershipPlanMenu.showForUsersWithoutActiveSubscription,
              roleInRestricted: membershipPlanMenu.restricted_to.includes(role),
            }
          : null,
        filteredMenus: menus.map(m => m.name),
        membershipPlanInFiltered: menus.some(m => m.name === "Membership plan"),
      });
    }

    return menus;
  }

  static getMenusForMobileByRole(role, _hasActiveSubscription = false) {
    const menus = this.mobileSidebarMenus.filter(menu => {
      // Check if menu is restricted to this role
      const isRoleAllowed = menu.restricted_to.includes(role);

      // Special handling for Membership Plan menu - always show it if role is allowed
      if (menu.showForUsersWithoutActiveSubscription) {
        // Always show Membership Plan if user role is allowed (regardless of subscription status)
        return isRoleAllowed;
      }

      return isRoleAllowed;
    });
    return menus;
  }

  static hideCard = process.env.REACT_APP_HIDE_CARD;
  static hideMobileWalletAccount = process.env.REACT_APP_HIDE_NEW_MOBILE_ACCOUNT;
  static paymentProcessingTimeout = process.env.REACT_APP_PAYMENT_PROCESSING_TIMEOUT;
  static maxFileSizeLimit = process.env.REACT_APP_MAX_FILE_SIZE_LIMIT;
  static paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

  static isSandboxEnvironment() {
    return window.location.hostname.includes("sandbox") || window.location.hostname === "localhost";
  }
}

// Centralized Role and Organization Management
export class RoleConstants {
  // Organization Types
  static ORG_TYPES = {
    PLATFORM_ADMIN: {
      id: 1,
      code: "PLATFORM_ADMIN",
      name: "Platform admin organization",
    },
    HOST_PROPERTY_DISTRIBUTION: {
      id: 2,
      code: "HOST_PROPERTY_DISTRIBUTION",
      name: "Host Property Distribution",
    },
    HOST_PROPERTY_MANAGEMENT: {
      id: 3,
      code: "HOST_PROPERTY_MANAGEMENT",
      name: "Host Property Management",
    },
    CORPORATE_CUSTOMER: {
      id: 4,
      code: "CORPORATE_CUSTOMER",
      name: "Corporate customer",
    },
    INDIVIDUAL_SUBSCRIBER: {
      id: 5,
      code: "INDIVIDUAL_SUBSCRIBER",
      name: "Individual subscriber organization",
    },
    HOST_CORPORATE_CUSTOMER: {
      id: 6,
      code: "HOST_CORPORATE_CUSTOMER",
      name: "Host Corporate Customer",
    },
  };

  // Complete Role Definitions
  static ROLES = {
    // Platform Admin (Org Type 1)
    ROLE_ADMINISTRATOR: {
      code: "ROLE_ADMINISTRATOR",
      name: "Platform Admin",
      type: "Admin",
      orgTypeId: 1,
      orgTypeCode: "PLATFORM_ADMIN",
      parentOrgType: null,
      description: "Platform administrator with full system access",
    },

    // Host Property Distribution (Org Type 2)
    ROLE_HOST: {
      code: "ROLE_HOST",
      name: "Spacia Host Admin",
      type: "Spacia Host Admin",
      orgTypeId: 2,
      orgTypeCode: "HOST_PROPERTY_DISTRIBUTION",
      parentOrgType: null,
      description: "Host admin for property distribution",
    },
    ROLE_HOST_OPERATIONS: {
      code: "ROLE_HOST_OPERATIONS",
      name: "Spacia Host Non-admin",
      type: "Spacia Host Non-admin",
      orgTypeId: 2,
      orgTypeCode: "HOST_PROPERTY_DISTRIBUTION",
      parentOrgType: null,
      description: "Host operations for property distribution",
    },

    // Host Property Management (Org Type 3)
    ROLE_SUBSCRIBER_HOST: {
      code: "ROLE_SUBSCRIBER_HOST",
      name: "Spacia Property Management Host Admin",
      type: "Spacia Property Management Host Admin",
      orgTypeId: 3,
      orgTypeCode: "HOST_PROPERTY_MANAGEMENT",
      parentOrgType: null,
      description: "Property management host admin",
    },
    ROLE_SUBSCRIBER_HOST_OPERATIONS: {
      code: "ROLE_SUBSCRIBER_HOST_OPERATIONS",
      name: "Spacia Property Management Host Non-admin",
      type: "Spacia Property Management Host Non-admin",
      orgTypeId: 3,
      orgTypeCode: "HOST_PROPERTY_MANAGEMENT",
      parentOrgType: null,
      description: "Property management host operations",
    },
    ROLE_HOST_CUSTOMER_INDIVIDUAL: {
      code: "ROLE_HOST_CUSTOMER_INDIVIDUAL",
      name: "Individual customer of a specific property management host",
      type: "Individual customer of a specific property management host",
      orgTypeId: 3,
      orgTypeCode: "HOST_PROPERTY_MANAGEMENT",
      parentOrgType: 3,
      description: "Individual customer of property management host",
    },

    // Corporate Customer (Org Type 4)
    ROLE_SUBSCRIBER_OWNER: {
      code: "ROLE_SUBSCRIBER_OWNER",
      name: "Spacia corporate customer admin",
      type: "Spacia corporate customer admin",
      orgTypeId: 4,
      orgTypeCode: "CORPORATE_CUSTOMER",
      parentOrgType: null,
      description: "Corporate customer administrator",
    },
    ROLE_APPROVER_EMPLOYEE: {
      code: "ROLE_APPROVER_EMPLOYEE",
      name: "Spacia corporate customer sub-admin",
      type: "Spacia corporate customer sub-admin",
      orgTypeId: 4,
      orgTypeCode: "CORPORATE_CUSTOMER",
      parentOrgType: null,
      description: "Corporate customer approver employee",
    },
    ROLE_EMPLOYEE: {
      code: "ROLE_EMPLOYEE",
      name: "Spacia corporate customer non-admin",
      type: "Spacia corporate customer non-admin",
      orgTypeId: 4,
      orgTypeCode: "CORPORATE_CUSTOMER",
      parentOrgType: null,
      description: "Corporate customer employee",
    },

    // Individual Subscriber (Org Type 5)
    ROLE_SUBSCRIBER_INDIVIDUAL: {
      code: "ROLE_SUBSCRIBER_INDIVIDUAL",
      name: "Spacia individual customer",
      type: "Spacia individual customer",
      orgTypeId: 5,
      orgTypeCode: "INDIVIDUAL_SUBSCRIBER",
      parentOrgType: null,
      description: "Individual subscriber customer",
    },

    // Host Corporate Customer (Org Type 6)
    ROLE_HOST_CUSTOMER_OWNER: {
      code: "ROLE_HOST_CUSTOMER_OWNER",
      name: "Host corporate customer admin (for property management hosts only)",
      type: "Host corporate customer admin (for property management hosts only)",
      orgTypeId: 6,
      orgTypeCode: "HOST_CORPORATE_CUSTOMER",
      parentOrgType: 3,
      description: "Host corporate customer administrator",
    },
    ROLE_HOST_CUSTOMER_APPROVER_EMPLOYEE: {
      code: "ROLE_HOST_CUSTOMER_APPROVER_EMPLOYEE",
      name: "Host corporate customer sub-admin (for property management hosts only)",
      type: "Host corporate customer sub-admin (for property management hosts only)",
      orgTypeId: 6,
      orgTypeCode: "HOST_CORPORATE_CUSTOMER",
      parentOrgType: 3,
      description: "Host corporate customer approver employee",
    },
    ROLE_HOST_CUSTOMER_EMPLOYEE: {
      code: "ROLE_HOST_CUSTOMER_EMPLOYEE",
      name: "Host corporate customer non-admin (for property management hosts only)",
      type: "Host corporate customer non-admin (for property management hosts only)",
      orgTypeId: 6,
      orgTypeCode: "HOST_CORPORATE_CUSTOMER",
      parentOrgType: 3,
      description: "Host corporate customer employee",
    },
  };

  // Role Groups for Easy Access
  static ROLE_GROUPS = {
    // Host roles (main host dashboard)
    HOST_ROLES: ["ROLE_HOST", "ROLE_HOST_OPERATIONS", "ROLE_SUBSCRIBER_HOST", "ROLE_SUBSCRIBER_HOST_OPERATIONS"],

    // Host customer roles (customer dashboard)
    HOST_CUSTOMER_ROLES: [
      "ROLE_HOST_CUSTOMER_INDIVIDUAL",
      "ROLE_HOST_CUSTOMER_OWNER",
      "ROLE_HOST_CUSTOMER_APPROVER_EMPLOYEE",
      "ROLE_HOST_CUSTOMER_EMPLOYEE",
      // Human-readable names from organizationRole.name
      "Host Corporate Customer Owner",
      "Host Corporate Customer Employee",
      "Host Corporate Customer Approver Employee",
      "Host Individual Customer",
    ],

    // Admin roles
    ADMIN_ROLES: ["ROLE_ADMINISTRATOR"],

    // Individual subscriber roles
    INDIVIDUAL_SUBSCRIBER_ROLES: ["ROLE_SUBSCRIBER_INDIVIDUAL"],

    // Corporate customer roles
    CORPORATE_CUSTOMER_ROLES: ["ROLE_SUBSCRIBER_OWNER", "ROLE_APPROVER_EMPLOYEE", "ROLE_EMPLOYEE"],

    // All roles that should see host experience
    HOST_EXPERIENCE_ROLES: [
      "ROLE_HOST",
      "ROLE_HOST_OPERATIONS",
      "ROLE_SUBSCRIBER_HOST",
      "ROLE_SUBSCRIBER_HOST_OPERATIONS",
      "ROLE_HOST_CUSTOMER_INDIVIDUAL",
      "ROLE_HOST_CUSTOMER_OWNER",
      "ROLE_HOST_CUSTOMER_APPROVER_EMPLOYEE",
      "ROLE_HOST_CUSTOMER_EMPLOYEE",
    ],

    // Roles that can access admin dashboard
    ADMIN_DASHBOARD_ROLES: ["ROLE_ADMINISTRATOR"],

    // Roles that can access pricing page
    PRICING_ROLES: ["ROLE_SUBSCRIBER_INDIVIDUAL", "ROLE_SUBSCRIBER_OWNER", "ROLE_APPROVER_EMPLOYEE", "ROLE_EMPLOYEE"],

    // Admin-only roles that can upgrade subscription (organization admins)
    UPGRADE_ALLOWED_ROLES: [
      "ROLE_HOST",
      "ROLE_SUBSCRIBER_HOST",
      "ROLE_SUBSCRIBER_OWNER",
      "ROLE_SUBSCRIBER_INDIVIDUAL",
      "ROLE_HOST_CUSTOMER_OWNER",
      "ROLE_HOST_CUSTOMER_INDIVIDUAL",
    ],
  };

  // Navigation Paths by Role
  static ROLE_NAVIGATION = {
    ROLE_ADMINISTRATOR: "/dashboard",
    ROLE_HOST: "/host/dashboard",
    ROLE_HOST_OPERATIONS: "/host/dashboard",
    ROLE_SUBSCRIBER_HOST: "/host/dashboard",
    ROLE_SUBSCRIBER_HOST_OPERATIONS: "/host/dashboard",
    ROLE_HOST_CUSTOMER_INDIVIDUAL: "/host/customer-dashboard",
    ROLE_HOST_CUSTOMER_OWNER: "/host/customer-dashboard",
    ROLE_HOST_CUSTOMER_APPROVER_EMPLOYEE: "/host/customer-dashboard",
    ROLE_HOST_CUSTOMER_EMPLOYEE: "/host/customer-dashboard",
    ROLE_SUBSCRIBER_INDIVIDUAL: "/startbooking",
    ROLE_SUBSCRIBER_OWNER: "/startbooking",
    ROLE_APPROVER_EMPLOYEE: "/startbooking",
    ROLE_EMPLOYEE: "/startbooking",
  };

  // Utility Methods
  static getRoleInfo(roleCode) {
    return this.ROLES[roleCode] || null;
  }

  static getOrgTypeInfo(orgTypeId) {
    return Object.values(this.ORG_TYPES).find(type => type.id === orgTypeId) || null;
  }

  static getOrgTypeInfoByCode(orgTypeCode) {
    return Object.values(this.ORG_TYPES).find(type => type.code === orgTypeCode) || null;
  }

  static isRoleInGroup(roleCode, groupName) {
    const group = this.ROLE_GROUPS[groupName];
    return group ? group.includes(roleCode) : false;
  }

  static getNavigationPath(roleCode) {
    return this.ROLE_NAVIGATION[roleCode] || "/dashboard";
  }

  static getAllRolesForOrgType(orgTypeId) {
    return Object.values(this.ROLES).filter(role => role.orgTypeId === orgTypeId);
  }

  static getRolesByParentOrgType(parentOrgTypeId) {
    return Object.values(this.ROLES).filter(role => role.parentOrgType === parentOrgTypeId);
  }
}

// Host Clients specific constants (Legacy - keeping for backward compatibility)
export class HostClientsConstants {
  static ORG_ROLE_CODE_TO_ID = {
    ROLE_ADMINISTRATOR: "68630f4875b4bb01e95a1977",
    ROLE_HOST: "686d27bbe73e3a8bcd2f3d1f",
    ROLE_HOST_OPERATIONS: "686d2989ae5d6ab0400b225c",
    ROLE_SUBSCRIBER_HOST: "686d2a5dae5d6ab0400b225d",
    ROLE_SUBSCRIBER_HOST_OPERATIONS: "686d2a5fae5d6ab0400b225e",
    ROLE_SUBSCRIBER_OWNER: "686d2b90ae5d6ab0400b225f",
    ROLE_EMPLOYEE: "686d2b90ae5d6ab0400b2260",
    ROLE_APPROVER_EMPLOYEE: "686d2b92ae5d6ab0400b2261",
    ROLE_SUBSCRIBER_INDIVIDUAL: "686d2c15ae5d6ab0400b2262",
  };

  static ORG_ROLES = [
    {
      id: "68630f4875b4bb01e95a1977",
      code: "ROLE_ADMINISTRATOR",
      name: "Platform Admin",
      organizationTypeId: 1,
    },
    {
      id: "686d27bbe73e3a8bcd2f3d1f",
      code: "ROLE_HOST",
      name: "Property Distribution Host",
      organizationTypeId: 2,
    },
    {
      id: "686d2989ae5d6ab0400b225c",
      code: "ROLE_HOST_OPERATIONS",
      name: "Property Distribution Operations",
      organizationTypeId: 2,
    },
    {
      id: "686d2a5dae5d6ab0400b225d",
      code: "ROLE_SUBSCRIBER_HOST",
      name: "Property Management Host",
      organizationTypeId: 3,
    },
    {
      id: "686d2a5fae5d6ab0400b225e",
      code: "ROLE_SUBSCRIBER_HOST_OPERATIONS",
      name: "Property Management Operations",
      organizationTypeId: 3,
    },
    {
      id: "686d2b90ae5d6ab0400b225f",
      code: "ROLE_SUBSCRIBER_OWNER",
      name: "Corporate Owner",
      organizationTypeId: 4,
    },
    {
      id: "686d2b90ae5d6ab0400b2260",
      code: "ROLE_EMPLOYEE",
      name: "Corporate Employee",
      organizationTypeId: 4,
    },
    {
      id: "686d2b92ae5d6ab0400b2261",
      code: "ROLE_APPROVER_EMPLOYEE",
      name: "Corporate Approver Employee",
      organizationTypeId: 4,
    },
    {
      id: "686d2c15ae5d6ab0400b2262",
      code: "ROLE_SUBSCRIBER_INDIVIDUAL",
      name: "Individual Subscriber",
      organizationTypeId: 5,
    },
  ];

  static INITIAL_INVITE_USER_STATE = {
    username: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    msisdn: "",
    role: "",
  };

  static INITIAL_CREATE_ORG_STATE = {
    name: "Test Organization",
    code: "TEST123",
    contactEmail: "edem.agbakpe@outlook.com",
    alternateEmail: "alt@testorg.com",
    contactMsisdn: "+254700123456",
    address: "123 Test Street",
    city: "Nairobi",
    region: "Nairobi County",
    countryId: 119, // Kenya
    logoUrl: "https://example.com/logo.png",
    webUrl: "https://testorg.com",
    typeId: 4, // Default to Corporate Customer
    config: {
      maxUsers: 10,
      enableMonthlyStatementAlerts: true,
    },
    adminProfile: {
      lastName: "Admin",
      firstName: "Test",
      msisdn: "+254700123457",
      emailAddress: "edem.agbakpe@outlook.com",
      username: "testhostcustomer",
    },
  };

  // Role-based access control constants (using new centralized system)
  static HOST_ROLES = RoleConstants.ROLE_GROUPS.HOST_ROLES;
  static HOST_CUSTOMER_ROLES = RoleConstants.ROLE_GROUPS.HOST_CUSTOMER_ROLES;
  static ADMIN_ROLES = RoleConstants.ROLE_GROUPS.ADMIN_ROLES;
}
